import { ExternalLink } from "lucide-react";
import Reveal, { Overline } from "./Reveal";
import { PRESS_COVERAGE } from "../data/content";

export default function PressCoverage() {
  return (
    <section data-testid="press" className="border-y border-line bg-surface/60 py-24 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <Overline>In The News</Overline>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-medium uppercase leading-[0.95] tracking-tighter sm:text-5xl">
            The salvage that{" "}
            <span className="font-serif italic font-medium tracking-normal normal-case text-brand">
              made headlines
            </span>
          </h2>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-steel sm:text-lg">
            The refloating of the Royal Malaysian Navy's KD Pendekar was covered
            across national and international media — a recovery led by the
            Udat Marine salvage team.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PRESS_COVERAGE.map((p, i) => (
            <Reveal key={p.url} delay={i * 0.06} className="h-full">
              <a
                data-testid={`press-card-${i}`}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-full flex-col border border-line bg-ink p-6 transition-colors duration-300 hover:border-brand"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand">
                    {p.source}
                  </span>
                  <span className="font-mono text-[9px] uppercase tracking-[0.16em] text-steel">
                    {p.date}
                  </span>
                </div>
                <h3 className="mt-4 flex-1 font-display text-lg uppercase leading-snug tracking-tight text-slate-100">
                  "{p.headline}"
                </h3>
                <span className="mt-5 flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.18em] text-steel transition-colors group-hover:text-brand">
                  Read coverage
                  <ExternalLink size={11} />
                </span>
              </a>
            </Reveal>
          ))}

          <Reveal delay={0.3} className="h-full">
            <div className="flex h-full flex-col justify-center border border-brand/40 bg-brand/10 p-6">
              <p className="font-display text-xl uppercase leading-snug tracking-tight text-white">
                Need a salvage team with a proven record?
              </p>
              <p className="mt-3 text-sm font-light leading-relaxed text-steel">
                Our duty officer responds around the clock — WhatsApp
                +6017-7529304.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
